import Banner from "./landing/Banner";
import Benefits from "./landing/Benefits";
import GlobalExpansion from "./landing/GlobalExpansion";
import HowTo from "./landing/HowTo";
import Partners from "./landing/Partners";
import Statistics from "./landing/Statistics";
import WhyStake from "./landing/WhyStake";

export default function Landing() {
    return (
        <div>
            <Banner />
            <GlobalExpansion />
            <Partners />
            <Benefits />
            <HowTo />
            {/* <WhyStake /> */}
            <Statistics />
        </div>
    )
}